export default "/img/CK.73160e6db9471a89dc080f187700ff12.png";